import { formatISO } from 'date-fns';

export const dateFormatter = (date: Date | string): string => {
  return formatISO(new Date(date)).split('T')[0];
};
export const datePickerFormatter = (v: Date): { start: any; end: any } => {
  return {
    start: dateFormatter(v).concat('T00:00:00.000Z'),
    end: dateFormatter(v).concat('T00:00:00.000Z'),
  };
};
export const changeTimeFormatToJsonFormat = (
  date: Date
): string | number | Date => new Date(date).toISOString();
